import { render } from "./Tag.vue?vue&type=template&id=0e83f9b8"
import script from "./Tag.vue?vue&type=script&lang=js"
export * from "./Tag.vue?vue&type=script&lang=js"

import "./Tag.vue?vue&type=style&index=0&id=0e83f9b8&lang=scss"

import exportComponent from "/Users/ondaa/workspace/schoolmom_qna_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__